import { useContext } from 'react';
import { ForecastContext } from './ForecastContext';

export function useForecast() {
  const ctx = useContext(ForecastContext);
  if (!ctx) throw new Error('useForecast must be used within ForecastProvider');
  return ctx;
}
